<template>
<div id="store-featured" class="col container-large mt-4">
          <img id="character-img" src="@/assets/img/STORE_nanabozho.png">
          <div class="header-block centered">
            <h3 class="blue">Shop our interactive products {{displayNumber}}</h3>
            <h4 class="blue">or find a <router-link to="/retailers" class="underline">retailer</router-link> close to you</h4>
          </div>
          <div id="featured-products" class="grid grid-3">
            <ProductThumbnail v-for="(product, index) in products" v-bind:key="product.name" :product="product"></ProductThumbnail>
            <button class="full dark grid-middle-item no-m" @click="goToShop()">Go to shop</button>
          </div>
        </div>
</template>


<script>
import ProductThumbnail from "@/components/ProductThumbnail.vue";
import router from "@/router/index.js";

export default {
  name: "StoreFeaturedProducts",
  components: {ProductThumbnail},
  computed: {
    products() {
      return this.$store.getters.getFeaturedProducts;
    },
  },
  methods: {
    goToShop() {
      router.push('/shop');
    },
  }
}
</script>


<style scoped lang="scss">
#store-featured {
  padding-top: 4em;
  align-items: center;
  position: relative;

  a.underline {
    text-decoration: underline;
  }

  h3 {
    padding: 0;
  }
  h4 {
    font-weight: normal;
    padding: 0;
  }

  .header-block {
    padding-bottom: 3em;
  }


  #featured-products {
    padding-bottom: 2em;
    width: 80%;
  }

  #character-img {
    max-width: 180px;
  }

  .grid-middle-item {
    grid-column: 2 / 3;
  }
}

@media only screen and (max-width: 747px) {
  #store-featured  {
    .grid.grid-3 {
      grid-template-columns: repeat(1, 1fr);
      gap: 1em;
    }

    .grid-middle-item {
      grid-column: unset;
    }
    #featured-products {
      width: 100%;
    }

  }
}
</style>